<form *ngIf="copyLoaded" #formEmailCheck="ngForm" id="enterEmail" name="formEmailCheck" (submit)="handleSubmitEmailCheck(formEmailCheck.value, $event)" novalidate>
  <h3 class="text-dark-blue">{{ appCopy.panelHeader['title'+selectedLanguage] }}</h3>
  <p class="text-muted text-dark-blue" *ngIf="!userNotFound">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>
  <p class="text-muted text-danger text-dark-blue" *ngIf="userNotFound">{{ appCopy.panelHeader['userNotFound'+selectedLanguage] }} <a href="javascript:void(0)" (click)="goToRegister()">{{ appCopy.panelHeader['btnRegister'+selectedLanguage] }}</a>.</p>

  <div class="form-group">
    <input class="form-control"
            [ngClass]="{ 'has-error' : email.invalid && email.dirty }"
            id="email"
            name="email"
            type="email"
            #email="ngModel"
            [pattern]="emailPattern"
            ngModel
            required>
    <label class="control-label" for="email">{{ appCopy.panelHeader['emailPlaceholder'+selectedLanguage] }}</label>
    <p class="help-block text-danger" *ngIf="email?.errors?.pattern"> {{ appCopy.panelHeader['validEmail'+selectedLanguage] }}</p>
    <p class="help-block text-danger" *ngIf="email.invalid && email.dirty && !email?.errors?.pattern">{{ appCopy.panelHeader['warningEmail'+selectedLanguage] }}</p>
  </div>

  <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="formEmailCheck.invalid">
    <div class="loader-container-btn" *ngIf="showLoader">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{ appCopy.panelHeader['btnNext'+selectedLanguage] }}
  </button>

  <div class="hr-text text-center text-muted margin-top-32 margin-bottom-32">
    <span>{{ appCopy.panelHeader['orText'+selectedLanguage] }}</span>
  </div>
  <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block" (click)="goToRegister()">
    {{ appCopy.panelHeader['btnRegister'+selectedLanguage] }}
  </button>
</form>
